import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import api from '../services/api';
import Button from '../components/Button';

const ProductPage = () => {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);
  const [shop, setShop] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  console.log(product)

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const productRes = await api.get(`/products/${productId}`);
        setProduct(productRes.data);
        const shopRes = await api.get(`/shops/${productRes.data.shop}`);
        setShop(shopRes.data);
      } catch (err) {
        setError('Nie udało się pobrać danych produktu.');
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [productId]);

  const handlePurchase = async () => {
  if (!shop.paymentSettings?.stripe?.publicKey) {
    setError('Płatności Stripe nie są skonfigurowane dla tego sklepu.');
    return;
  }

  try {
    const stripe = await loadStripe(shop.paymentSettings.stripe.publicKey);

    const response = await api.post('/payments/create-checkout-session', {
      productId: product._id // <- tutaj wysyłasz tylko ID produktu
    });

    const session = response.data;

    const result = await stripe.redirectToCheckout({
      sessionId: session.id,
    });

    if (result.error) {
      setError(result.error.message);
    }
  } catch (err) {
    setError(err.response?.data?.message || 'Wystąpił błąd podczas próby zakupu.');
  }
};


  if (loading) return <div className="text-center py-10">Ładowanie...</div>;
  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;
  if (!product) return <div className="text-center py-10">Nie znaleziono produktu.</div>;

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="bg-gray-800 rounded-lg shadow-xl overflow-hidden md:flex">
        <div className="md:w-1/2">
          <img src={product.imageUrl ? `${product.imageUrl}` : 'https://placehold.co/600x400'} alt={product.name} className="w-full h-full object-cover" />
        </div>
        <div className="md:w-1/2 p-8 flex flex-col justify-between">
          <div>
            <h1 className="text-4xl font-bold text-white mb-4">{product.name}</h1>
            <p className="text-gray-300 mb-6">{product.description}</p>
            <div className="text-3xl font-bold text-indigo-400 mb-6">{product.price} PLN</div>
          </div>
          <Button onClick={handlePurchase} className="w-full bg-indigo-600 hover:bg-indigo-700">
            Kup teraz
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProductPage;